import Marty from "marty";

const USER_CONSTANTS = Marty.createConstants([
    "CANCEL_ORDER"
]);

export default USER_CONSTANTS;



/** WEBPACK FOOTER **
 ** ./app/constants/userConstants.js
 **/